export const menuItems = [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },

  {
    id: 2,
    label: "menuitems.dashboards.text",
    icon: "bx-home-circle",
    subItems: [
      {
        id: 3,
        label: "menuitems.dashboards.list.default",
        link: "/",
        parentId: 2,
      },

      {
        id: 4,
        label: "menuitems.dashboards.list.saas",
        link: "/",
        parentId: 2,
      },

      {
        id: 5,
        label: "menuitems.dashboards.list.crypto",
        link: "/",
        parentId: 2,
      },
    ],
  },

  {
    id: 108,
    label: "menuitems.lodgings.text",
    icon: "bx-hotel",
    link: "/lodgings",
  },

  {
    id: 8,
    label: "menuitems.calendar.text",
    icon: "bx-calendar",
    link: "/calendar",
  },

  {
    id: 109,
    label: "menuitems.employees.text",
    icon: "bx-user",
    link: "/employees",
  },

  {
    id: 112,
    label: "menuitems.bookings.text",
    icon: "bx-calculator",
    link: "/bookings",
  },

  {
    id: 110,
    label: "menuitems.customers.text",
    icon: "bxs-user-detail",
    link: "/customers",
  },

  {
    id: 111,
    label: "menuitems.settings.text",
    icon: "bx-cog",
    link: "/settings",
  },
];
